import useLocalStorageState from '@/hooks/common/useLocalStorageState';
import { formatDate } from '@/lib/dateTime';
import { useIsAuthenticated } from '@azure/msal-react';
import { useCallback, useEffect } from 'react';

const UNAUTH_SEARCH_COUNT_KEY = 'unauthSearchCount';
const MAX_UNAUTH_SEARCHES = 10;

type SearchCountDataType = Record<string, number>;

const getKeyForToday = () => formatDate(new Date());

const usePublicSearchLimit = () => {
  const isAuthenticated = useIsAuthenticated();

  const todayKey = getKeyForToday();

  const [searchCount, setSearchCount] =
    useLocalStorageState<SearchCountDataType>(
      { [todayKey]: 0 },
      UNAUTH_SEARCH_COUNT_KEY,
    );

  const increaseSearchCount = useCallback(() => {
    if (!isAuthenticated) {
      setSearchCount((searchCount) => {
        const todayCount = searchCount[todayKey] || 0;
        return {
          [todayKey]: todayCount + 1,
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, setSearchCount]);

  useEffect(() => {
    if (isAuthenticated) {
      setSearchCount({ [todayKey]: 0 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return {
    increaseSearchCount,
    hasReachedSearchLimit:
      !isAuthenticated && searchCount[todayKey] >= MAX_UNAUTH_SEARCHES,
  };
};

export default usePublicSearchLimit;
